module.exports = __webpack_public_path__ + "static/apple-touch-icon-41e1bae4a4e3bce2cd3109d4ff789b61.png";